import { CHANGE_BLOCK_LEVEL } from './constants'

// eslint-disable-next-line import/prefer-default-export
export function changeBlockLevel(module, id, blockKey, value) {
    return {
        type: CHANGE_BLOCK_LEVEL,
        data: {
            module,
            id,
            blockKey,
            value,
        },
    }
}
